module.exports = __webpack_public_path__ + "static/maven-logo-f2f78945ff75abdbb9d79f5fd6fc7ad0.png";